import { Drawer as MuiDrawer } from "@mui/material";
import * as React from "react";

import styles from "./Drawer.module.css";

interface DrawerProps extends React.PropsWithChildren {
  /** Whether the drawer is open. */
  isOpen: boolean;

  /** Callback to close the drawer. */
  onClose: () => void;
}

/**
 * A drawer component containing the navigation links.
 */
export function Drawer(props: DrawerProps) {
  return (
    <MuiDrawer
      anchor="left"
      open={props.isOpen}
      onClose={props.onClose}
      PaperProps={{
        className: styles.drawer,
      }}
    >
      {props.children}
    </MuiDrawer>
  );
}
